import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=7d6d232a&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"
import style0 from "./OrderList.vue?vue&type=style&index=0&id=7d6d232a&prod&lang=scss"
import style1 from "./OrderList.vue?vue&type=style&index=1&id=7d6d232a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6d232a",
  null
  
)

export default component.exports